import styled, { css } from 'styled-components';
import { colors } from '../../../../theme/style-helpers';
import ChevronOrange from '../../../../assets/icons/chevron_right_icon_orange.svg';
import ChevronWhite from '../../../../assets/icons/chevron_right_icon_white.svg';
import ChevronGray from '../../../../assets/icons/chevron_right_icon_gray.svg';

export const Label = styled.p`
    font-weight: ${({ size }) => (size === 'large' ? '600' : '500')};
    font-size: ${({ size }) => (size === 'large' ? '18px' : '16px')};
    line-height: ${({ size }) => (size === 'large' ? '27px' : '24px')};
    padding-top: ${({ size }) => (size === 'large' ? '2px' : '0')};
    padding-bottom: ${({ size }) => (size === 'large' ? '3px' : '0')};
    color: ${colors.WHITE};
    margin: 0;
    padding-right: 0px;
    width: max-content;
    display: flex;
    align-items: center;
    ${({ showarrow }) => showarrow === 'true' && css`
        background-image: url(${ChevronOrange});
        background-repeat: no-repeat;
        background-position: center right;
        padding-right: 26px;
    `};
`;

export const Container = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 12px 24px;
    min-width: 156px;
    width: ${({ fill }) => (fill ? '100%' : 'inherit')};
    background-color: ${colors.BLACK};
    border-radius: 1px;
    border: none;
    cursor: pointer;

    &:hover:enabled {
        ${Label} {
            ${({ showarrow }) => showarrow === 'true' && css`
                background-image: url(${ChevronWhite});
            `};
        };
        outline: 1px solid #FFAF89;
        background-color: #E55916;
    }

    &:focus {
        outline: 2px solid ${colors.BRAND_ORANGE};
    }

    &:active:enabled {
        background-color: ${colors.ORANGE_SHADES_DARK1};
        outline: none;
    }

    &:disabled {
        background-color: ${colors.COOL_GREY};
        ${Label} {
            color: ${colors.DARK_GREY};
            ${({ showarrow }) => showarrow === 'true' && css`
                background-image: url(${ChevronGray});
            `};
        };
        cursor: not-allowed;
    }
`;
